import { isRejectedWithValue, type Middleware } from '@reduxjs/toolkit';

import { setAuthState } from './slice';

/**
 * Middleware to handle authentication errors from API calls
 * Sets unauthorized state when receiving 401/403 errors
 */
export const userAuthErrorMiddleware: Middleware = store => next => action => {
  // Check if this is a rejected RTK Query action
  if (isRejectedWithValue(action)) {
    const payload = action.payload as { status?: number } | undefined;

    // Check for authentication errors
    if (payload?.status === 401 || payload?.status === 403) {
      // Dispatch action to set unauthorized state
      store.dispatch(setAuthState({ unauthorized: true }));
    }
  }

  return next(action);
};
